import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGatewayMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  data: Types.UpdateGatewayData;
}>;


export type UpdateGatewayMutation = { __typename?: 'Mutation', updateGateway?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };


export const UpdateGatewayDocument = gql`
    mutation UpdateGateway($id: Int!, $data: UpdateGatewayData!) {
  updateGateway(id: $id, data: $data) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type UpdateGatewayMutationFn = Apollo.MutationFunction<UpdateGatewayMutation, UpdateGatewayMutationVariables>;

/**
 * __useUpdateGatewayMutation__
 *
 * To run a mutation, you first call `useUpdateGatewayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGatewayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGatewayMutation, { data, loading, error }] = useUpdateGatewayMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateGatewayMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGatewayMutation, UpdateGatewayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGatewayMutation, UpdateGatewayMutationVariables>(UpdateGatewayDocument, options);
      }
export type UpdateGatewayMutationHookResult = ReturnType<typeof useUpdateGatewayMutation>;
export type UpdateGatewayMutationResult = Apollo.MutationResult<UpdateGatewayMutation>;
export type UpdateGatewayMutationOptions = Apollo.BaseMutationOptions<UpdateGatewayMutation, UpdateGatewayMutationVariables>;